<div class="row" [ngClass]="{ 'pb-3 mb-2 border-bottom': isBroderBottom }" id="applied-filters-height">
    <div class="col-12">
        <div class="d-flex justify-content-between align-items-start">
            <div class="d-flex flex-wrap gap-2 align-items-center">
                <span class="text-secondary font-weight-semibold">{{ "label-title.applied-filters" | translate }}
                    :</span>
                @for (filter of appliedFiltersLabels; track $index) {
                <div class="applied-filter-tag border-radius">
                    @if (!filter.isDate && filter.valueCount > 1) {
                    <span class="fs-10 badge rounded-pill bg-secondary align-middle"> {{ filter.valueCount }} </span>
                    }
                    {{ filter.label | translate }}
                    <span class="text-secondary">
                        @if (filter.translateToCurrentLang) {
                        {{ getCurrentLanguageTranslatedValue(filter) }}
                        } @else if (filter.isDate) {
                        {{ helper.moment(filter.value.from,
                        "MM-DD-YYYY").tz(helper.displayTimezone).format(helper.DATE_FORMAT.MOMENT_DD_MMM_YYYY) }} -
                        {{ helper.moment(filter.value.to,
                        "MM-DD-YYYY").tz(helper.displayTimezone).format(helper.DATE_FORMAT.MOMENT_DD_MMM_YYYY) }}
                        }@else if (filter.translate) {
                        {{ getTranslatedValue(filter) }}
                        } @else {
                        {{ filter.value }} 
                        } @if(!filter.isDate || (filter.isDate && filterData.formattedDate !== initialFormattedDate)) {
                        <a href="javascript:void(0);" (click)="clearFilter(filter.key)">
                            <em class="ri-close-fill" style="font-size: 14px; vertical-align: middle"></em>
                        </a>
                        }
                    </span>
                </div>
                }
            </div>
            <button class="btn btn-secondary btn-sm mx-3 text-nowrap" (click)="clearAllFilter()">
                {{ "button-title.clear-all" | translate }}
            </button>
        </div>
    </div>
</div>